import React from "react"
import { observer } from "mobx-react-lite"

import Column from "@components/ui/BaseTable/Column"
import Row from "@components/ui/SimpleTable/Row"
import { useStore } from "@store"

const QueryHistoryTableHeader: React.FC = observer(() => {
  const { restrictionsStore: access } = useStore()
  return (
    <Row>
      <Column as="th" key="solution" width="12%">
        Type
      </Column>
      <Column as="th" key="question" width="42%">
        Query
      </Column>
      <Column as="th" key="user" width="20%">
        User
      </Column>
      <Column as="th" key="dateTime" justify="center" width="10%">
        Date & Time
      </Column>
      <Column as="th" key="userFeedback" justify="center" width="72px">
        Rating
      </Column>
      {access.canViewQuestions && (
        <Column as="th" key="status" width="15%">
          Assign Status
        </Column>
      )}
    </Row>
  )
})

export default QueryHistoryTableHeader
